import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import useOnClickOutside from "common/hooks/useOnClickOutside"
import { AnimatePresence, motion } from "framer-motion"
import { useRef, useState } from "react"

const MultipleSelectionBox = ({
  handlePagination,
  handler,
  options,
  list = [],
}: $TSMigrationFixMe) => {
  const [show, setShow] = useState(false)
  const ref = useRef()
  // @ts-expect-error TS(2554): Expected 4 arguments, but got 2.
  useOnClickOutside(ref, () => setShow(false))

  const checkNotChecked = (item: $TSMigrationFixMe) => {
    // @ts-expect-error TS(7006): Parameter 'option' implicitly has an 'any' type.
    const exist = list.some((option) => option.id === item.id)

    return !exist
  }

  return (
    <div className='gedesbox'>
      <section
        className='multiple-selection-box'
        onClick={() => setShow(true)}
      >
        <div className='multiple-selection-box__list'>
          {/* @ts-expect-error TS(7006): Parameter 'item' implicitly has an 'any' type. */}
          {list?.map((item) => (
            <div
              key={Math.random()}
              className='multiple-selection-box__item'
            >
              <p>
                {item.nombre} |{" "}
                <span
                  onClick={() =>
                    handler(
                      // @ts-expect-error TS(7006): Parameter 'itemSelected' implicitly has an 'any' t...
                      list.filter((itemSelected) => item.id !== itemSelected.id)
                    )
                  }
                >
                  X
                </span>
              </p>
            </div>
          ))}
        </div>
        <div className='multiple-selection-box__settings'>
          <FontAwesomeIcon
            onClick={() => handler([])}
            icon={["fal", "xmark"]}
          />
          <FontAwesomeIcon
            onClick={() => setShow(true)}
            icon={["fal", "angle-down"]}
          />
        </div>
      </section>
      {show &&
      options.filter((item: $TSMigrationFixMe) => checkNotChecked(item))
        .length ? (
        <AnimatePresence>
          <motion.div
            initial='initial'
            animate='animate'
            exit='exit'
            // @ts-expect-error TS(2322): Type 'MutableRefObject<undefined>' is not assignab...
            ref={ref}
          >
            <section
              className='multiple-selection-options'
              onScroll={(e) => {
                const target = e.currentTarget
                const buffer = 1
                if (
                  target.scrollTop + target.clientHeight >=
                  target.scrollHeight - buffer
                ) {
                  handlePagination()
                }
              }}
            >
              {options
                .filter((item: $TSMigrationFixMe) => checkNotChecked(item))
                .map((item: $TSMigrationFixMe) => (
                  <p
                    className='multiple-selection-options__option'
                    key={Math.random()}
                    onClick={() => {
                      handler([...list, item])
                    }}
                  >
                    {item.nombre} {item.apellidos}
                  </p>
                ))}
            </section>
          </motion.div>
        </AnimatePresence>
      ) : (
        ""
      )}
    </div>
  )
}

export default MultipleSelectionBox
